import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

const ADMINHUB_POLICY_PREVIEW_CLIENT_ID_PREFIX = 'adminhub-policy-preview';

export const getAdminhubPolicyPreviewClientId = (
	conversationId: string,
	contentId: string,
): ClientId => client(`${ADMINHUB_POLICY_PREVIEW_CLIENT_ID_PREFIX}:${conversationId}:${contentId}`);
